import { Decimal } from "classes/DecimalClasses";

import { i18n } from "services/i18nService";

import { initialErrorState } from "views/common";

export function isValid(record) {
  const errors = isValidRates(record);

  if (!record.fromAddress.company) {
    errors.messages.push(i18n("isValid.upsShipment.fromCompany"));
    errors.entity.push("fromAddressCompany");
    errors.entity.push("fromAddress");
  }

  if (!record.fromAddress.address.line1) {
    errors.messages.push(i18n("isValid.upsShipment.fromLine1"));
    errors.entity.push("fromAddressLine1");
    errors.entity.push("fromAddress");
  }

  if (!record.fromAddress.address.city) {
    errors.messages.push(i18n("isValid.upsShipment.fromCity"));
    errors.entity.push("fromAddressCity");
    errors.entity.push("fromAddress");
  }

  if (!record.toAddress.company) {
    errors.messages.push(i18n("isValid.upsShipment.toCompany"));
    errors.entity.push("toAddressCompany");
    errors.entity.push("toAddress");
  }

  if (!record.toAddress.address.line1) {
    errors.messages.push(i18n("isValid.upsShipment.toLine1"));
    errors.entity.push("toAddressLine1");
    errors.entity.push("toAddress");
  }

  if (!record.toAddress.address.city) {
    errors.messages.push(i18n("isValid.upsShipment.toCity"));
    errors.entity.push("toAddressCity");
    errors.entity.push("toAddress");
  }

  if (!record.serviceCode) {
    errors.messages.push(i18n("isValid.upsShipment.serviceCode"));
    errors.entity.push("serviceCode");
  }

  if (record.returnServiceCode && !record.returnMerchandiseDescription) {
    errors.messages.push(
      i18n("isValid.upsShipment.returnMerchandiseDescription")
    );
    errors.entity.push("returnMerchandiseDescription");
  }
  // remove possible duplicate values
  errors.entity = [...new Set(errors.entity)];

  return errors;
}

export function isValidRates(record) {
  const errors = initialErrorState();
  if (!record.weight.gt(Decimal.ZERO)) {
    errors.messages.push(i18n("isValid.upsShipment.weight"));
    errors.entity.push("weight");
  }

  if (!record.toAddress.address.postalCode) {
    errors.messages.push(i18n("isValid.upsShipment.toPostalCode"));
    errors.entity.push("toAddressPostalCode");
    errors.entity.push("toAddress");
  }

  if (!record.fromAddress.address.postalCode) {
    errors.messages.push(i18n("isValid.upsShipment.fromPostalCode"));
    errors.entity.push("fromAddressPostalCode");
    errors.entity.push("fromAddress");
  }

  if (!record.toAddress.address.stateProvince) {
    errors.messages.push(i18n("isValid.upsShipment.toStateProvince"));
    errors.entity.push("toAddressStateProvince");
    errors.entity.push("toAddress");
  }

  if (!record.fromAddress.address.stateProvince) {
    errors.messages.push(i18n("isValid.upsShipment.fromStateProvince"));
    errors.entity.push("fromAddressStateProvince");
    errors.entity.push("fromAddress");
  }

  if (!record.upsAccount) {
    errors.messages.push(i18n("isValid.upsShipment.upsAccount"));
    errors.entity.push("upsAccount");
  }

  if (!record.rateType) {
    errors.messages.push(i18n("isValid.upsShipment.rateType"));
    errors.entity.push("rateType");
  }

  if (!record.deliveryConfirmationCode) {
    errors.messages.push(i18n("isValid.upsShipment.deliveryConfirmationCode"));
    errors.entity.push("deliveryConfirmationCode");
  }

  if (!record.packagingCode) {
    errors.messages.push(i18n("isValid.upsShipment.packagingCode"));
    errors.entity.push("packagingCode");
  }

  // remove possible duplicate values
  errors.entity = [...new Set(errors.entity)];

  return errors;
}
